import { useState } from "react";
import { useRouter } from "next/router";

function Checkbox({ name, text, value, cnt }) {
  const router = useRouter();
  const checkParam = router?.query[name]?.includes(value);
  const [isChecked, setIsChecked] = useState(checkParam);

  const content = () => {
      if (text) {
          if (cnt) {
              return (<span><span className={'font-bold'}>{text}</span> ({cnt})</span>);
          }
          return (<span className={'font-bold'}>{text}</span>);
      }

      return '';

  }
    return (
      <div className="flex items-center py-1 cursor-pointer">
        <input
          type="checkbox"
          name={name}
          value={value}
          id="geaccepteerd"
          className="hidden"
          checked={isChecked}
          readOnly
        />
        <div
          className={`before:content-[''] before:relative before:block before:w-4 before:h-4 before:border before:border-olaf-green-500 before:rounded-[3px] before:mr-4 ${
            isChecked ? "before:bg-olaf-green-500" : "before:bg-transparent"
          }`}
          onClick={() => (isChecked ? setIsChecked(false) : setIsChecked(true))}
        ></div>
        <label
          htmlFor={name}
          onClick={() => (isChecked ? setIsChecked(false) : setIsChecked(true))}
          className="text-olaf-green-700 cursor-pointer"
        >
            {content()}
        </label>
      </div>
    );
}

export default Checkbox;
